import { render, staticRenderFns } from "./EsteroSimple.vue?vue&type=template&id=71168b3a&scoped=true&"
import script from "./EsteroSimple.vue?vue&type=script&lang=js&"
export * from "./EsteroSimple.vue?vue&type=script&lang=js&"
import style0 from "./EsteroSimple.vue?vue&type=style&index=0&id=71168b3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71168b3a",
  null
  
)

export default component.exports